import axios from 'axios';
import {
  Message,
  MessageBox
} from 'element-ui'
import store from '@/store';
import {
  Dialog
} from 'vant';

// 创建axios实例
// 重定向 登录 界面
function redirectLogin(msg) {
  let url = window.location.pathname;
  if (!['/staffRecord', '/interviewRegister'].includes(url)) {
    if (store.getters.systemType === 'pc') {
      MessageBox.confirm(store.getters.authorization ? '当前用户登录时间超时，请重新登录' : '您还未登录，请先登录', '确认操作', {
        confirmButtonText: '确定',
        showCancelButton: false,
        type: 'warning'
      }).then(() => {
        store.dispatch('out')
      })
    } else {
      Dialog.alert({
        title: '提示',
        message: store.getters.authorization ? '当前用户登录时间超时，请重新登录' : '您还未登录，请先登录'
      }).then(() => {
        // on close
        store.dispatch('out')
      });
    }
  }
}

function errorLog(msg) {
  // 显示提示
  Message({
    message: msg,
    type: 'error',
    duration: 5 * 1000,
  });
}

function warnLog(msg) {
  // 显示提示
  Message({
    message: msg,
    type: 'warning',
    duration: 5 * 1000,
  });
}

const service = axios.create({
  baseURL: '/api', // api的base_url
  timeout: 30000, // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  config => {
    const {
      getLoginAuthForm,
      authorization,
      systemId,
      isSafing
    } = store.getters
    // 短信验证headers传参
    const {
      graphicCode,
      graphicState,
      phone,
      type,
      code,
      autographType,
      weChatUserId
    } = getLoginAuthForm
    if (getLoginAuthForm && getLoginAuthForm.phone) {
      // 赋值headers验证 短信验证接口
      if (config.url === '/jsConfig') {
        config.baseURL = '/wechat'
      }
      config.headers["graphicCode"] = graphicCode
      config.headers["graphicState"] = graphicState
      config.headers["autographType"] = autographType
      config.headers["phone"] = phone
      config.headers["type"] = type
      config.headers["code"] = code
      config.headers["weChatUserId"] = weChatUserId
    }
    if (isSafing && !config.safingPass) throw new Error('维护中！！！拒绝请求!')
    config.headers['authorization'] = authorization;
    config.headers['joineast-system-id'] = config.headers['joineast-system-id'] || systemId || 1;
    if (!window.location.origin) {
      window.location.origin = window.location.protocol + "//" + window.location.hostname +
        (window.location.port ? ':' + window.location.port : '');
    }
    let requestPath = window.location.href.replace(window.location.origin, "");
    config.headers['joineast-request-path'] = requestPath;
    if (config.config && config.config.isOut) {
      config.headers["platform-proxy"] = "am9pbmVhc3QtcGM=";
    }
    if (process.env.NODE_ENV === 'development') {
      config.headers['joineast-target'] = 'htd'
    }
    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  response => {
    // res 是 axios 返回数据中的 data
    const res = response.data;
    // 这个状态码是和后端约定的
    const code = res.status;
    // 根据 code 进行判断
    if (code === undefined) {
      // 如果没有 code 代表这不是项目后端开发的接口
      return res;
    } else {
      // 有 code 代表这是一个后端接口 可以进行进一步的判断
      switch (code) {
        case 200:
          // code === 200 代表没有错误
          return res;
        case 201:
          warnLog(`${res.msg}`, 201);
          break;
        case 202:
          warnLog(`${res.msg}`, 202);
          break;
        case 'xxx':
          // [ errorLog ] 其它和后台约定的 code
          errorCreate(`[ code: xxx ] ${res.msg}: ${response.config.url}`);
          break;
        default:
          // 不是正确的 code
          errorLog(`${res.msg}: ${response.config.url}`);
          break;
      }
    }
  },
  error => {
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '请求错误';
          break;
        case 401:
          error.message = '未授权，请登录';
          redirectLogin('未授权，请登录')
          break;
        case 403:
          error.message = '拒绝访问';
          redirectLogin('拒绝访问')
          break;
        case 404:
          error.message = `请求地址出错: ${error.response.config.url}`;
          break;
        case 408:
          error.message = '请求超时';
          break;
        case 500:
          // error.message = '服务器内部错误';
          error.message = error.response.data.message || error.response.data.msg || '服务器内部错误'
          break;
        case 501:
          error.message = '服务未实现';
          break;
        case 502:
          error.message = '网关错误';
          break;
        case 503:
          if (error.response.status === 503 && store.getters.systemType != 'pc') {
            store.dispatch('errOut')
          }
          error.message = error.response.data.msg;
          break;
        case 504:
          error.message = '网关超时';
          break;
        case 505:
          error.message = 'HTTP版本不受支持';
          break;
        default:
          break;
      }
    }
    console.log('err' + error); // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000,
    });
    return Promise.reject(error);
  }
);

export default service;